var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/risk-by-year/risk-by-year.html';
var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart config=$ctrl.chartConfig class=naers-report ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/reports/risk-by-year/risk-by-year.html
// module id = 724
// module chunks = 0